// ABOUTME: Which job actions the UI offers to the current user (retry, cancel, delete, resources).
// ABOUTME: Mirrors the server rules only to hide actions: the server enforces them on every call.

import { JobTypesByName } from '../hooks/useJobTypes/useJobTypes';
import { Jobs, NON_TERMINAL_JOB_STATES, TERMINAL_JOB_STATES } from '../types';

/** Roles that see, cancel and delete every job of the company. */
export const JOB_ADMIN_ROLES = ['COMPANY_ADMIN', 'PIM_ADMIN', 'PIM_SUPERADMIN'];

export const SUPERADMIN_ROLE = 'PIM_SUPERADMIN';

export type JobActor = { username?: string | null; roles: string[] };

const isJobAdmin = (actor: JobActor) => JOB_ADMIN_ROLES.some(role => actor.roles.includes(role));

export const isSuperAdmin = (actor: JobActor) => actor.roles.includes(SUPERADMIN_ROLE);

type JobLike = Pick<Jobs, 'type' | 'state' | 'createdBy' | 'cancelRequestedAt' | 'attemptsCount'>;

/** A retry starts a new attempt after a failed, timed out or cancelled one. */
export const canRetryJob = (job: JobLike, types: JobTypesByName) =>
    (job.state === 'failed' || job.state === 'cancelled') &&
    job.attemptsCount > 0 &&
    !!types[job.type]?.permissions.launch;

export const canCancelJob = (job: JobLike, actor: JobActor) =>
    NON_TERMINAL_JOB_STATES.includes(job.state) &&
    !job.cancelRequestedAt &&
    ((!!actor.username && job.createdBy?.username === actor.username) || isJobAdmin(actor));

export const canDeleteJob = (job: JobLike, actor: JobActor) =>
    TERMINAL_JOB_STATES.includes(job.state) && isJobAdmin(actor);
